module.exports = "/images/cg.svg?6e843330d4a3def1382a315012bc717f";